
export class EventService {
    private readonly eventTarget;

    constructor() {
        if (!globalThis.eventTarget) {
            globalThis.eventTarget = new EventTarget();
        }
        this.eventTarget = globalThis.eventTarget;
    }

    emit(eventName: 'productDataLoaded' | 'reloadDrawing' | 'reloadDoorDrawing' | 'colorChange' | 'sizeChange' | 'updateColorPrices' | 'updatePacketPrices' | 'updateAccessoriesPrices') {
        this.eventTarget.dispatchEvent(new Event(eventName));
    }

    getTarget(): EventTarget
    {
        return this.eventTarget;
    }
}
